NIRV.refreshCbar = function () {
  DEBUG && console.log(' NIRV.refreshCbar()');

  NIRV.autosave = false;

  $('#cbar').empty();

  if (NIRV.currentview == 'inbox')
    $('#cbar').prepend(`<h2>${NIRV.L.inbox}</h2><p>${NIRV.L.inbox_description}</p>`);

  if (NIRV.currentview == 'focus')
    $('#cbar').prepend(`<h2>${NIRV.L.focus}</h2><p>${NIRV.L.focus_description}</p>`);
  if (NIRV.currentview == 'next')
    $('#cbar').prepend(`<h2>${NIRV.L.next}</h2><p>${NIRV.L.next_description}</p>`);
  if (NIRV.currentview == 'later')
    $('#cbar').prepend(`<h2>${NIRV.L.later}</h2><p>${NIRV.L.later_description}</p>`);
  if (NIRV.currentview == 'scheduled')
    $('#cbar').prepend(`<h2>${NIRV.L.scheduled}</h2><p>${NIRV.L.scheduled_description}</p>`);
  if (NIRV.currentview == 'someday')
    $('#cbar').prepend(`<h2>${NIRV.L.someday}</h2><p>${NIRV.L.someday_description}</p>`);
  if (NIRV.currentview == 'waiting')
    $('#cbar').prepend(`<h2>${NIRV.L.waiting}</h2><p>${NIRV.L.waiting_description}</p>`);

  if (NIRV.currentview == 'projects')
    $('#cbar').prepend(
      `<h2>${NIRV.L.projects}</h2><p>${NIRV.L.projects_description}</p>`
    );
  if (NIRV.currentview == 'reflists')
    $('#cbar').prepend(`<h2>${NIRV.L.reference}</h2><p>${NIRV.L.reference_description}</p>`);

  if (NIRV.currentview == 'logbook')
    $('#cbar').prepend(
      `<h2>${NIRV.L.logbook}</h2><p>${NIRV.L.logbook_description}</p>`
    );
  if (NIRV.currentview == 'trash')
    $('#cbar').prepend(`<h2>${NIRV.L.trash}</h2><p>${NIRV.L.trash_description}</p>`);

  if (NIRV.currentview[0] == 'g' && NIRV.q == '') {
    var tag = NIRV.currentview.substr(1);
    if (tag == '__ALL__') tag = NIRV.L.all;
    if (tag == '__NONE__') tag = NIRV.L.no_tags;
    $('#cbar').prepend('<h2>' + tag + '</h2>');
  }

  if (NIRV.currentview[0] == 'z' && NIRV.q == '') {
    var pid = NIRV.currentview.substr(1);
    if (tag == '__ALL__') tag = NIRV.L.all;
    if (tag == '__NONE__') tag = NIRV.L.no_tags;
    $('#cbar').prepend('<h2>' + NIRV.tasks[pid].name + '</h2>');
  }

  if (
    NIRV.currentview[0] == 'p' &&
    NIRV.currentview != 'projects' &&
    NIRV.q == ''
  ) {
    var pid = NIRV.currentview.substr(1);
    if (NIRV.tasks[pid]) {
      $('#cbar').append(
        // '<h5 style="margin: 0 0 5px 5px; letter-spacing: 1px; font-size: 0.875rem; color: inherit;">PROJECT</h5>' +
        '<div class="tasklist" key="__id__' +
          pid +
          '"><ul class="tasks" sortby="seq" sortable="0">' +
          NIRV.tasks[pid].render() +
          '</ul></div>'
      );
    }
  }

  if (
    NIRV.currentview[0] == 'l' &&
    NIRV.currentview != 'later' &&
    NIRV.currentview != 'logbook' &&
    NIRV.q == ''
  ) {
    var pid = NIRV.currentview.substr(1);
    if (NIRV.tasks[pid]) {
      $('#cbar').append(
        '<div class="tasklist" key="__id__' +
          pid +
          '"><ul class="tasks" sortby="seq" sortable="0">' +
          NIRV.tasks[pid].render() +
          '</ul></div>'
      );
    }
  }

  $('#cbar').append('<ul class="filters"></ul>');

  var maintasks = {};
  var taskids = [];
  var task = {};
  var tags = '';
  var stags = '';
  var ctags = [];
  var areas = [];
  var contacts = [];
  var contexts = [];
  var tasktagcount = 0;
  var taskareatagcount = 0;
  var maintaskcount = 0;
  var noneflag = false;
  var etimeflag = false;
  var energyflag = false;
  var duecount = 0;
  var i, t;

  var xDue = function () {
    return NIRV.currentfilters.due ? 'on' : '';
  };

  var xEtime = function () {
    return NIRV.currentfilters.etime != -1 ? 'on' : '';
  };

  var xEnergy = function () {
    return NIRV.currentfilters.energy != -1 ? 'on' : '';
  };

  var xTag = function (tag) {
    if (NIRV.currentfilters.tags.includes(tag)) return 'on';
    if (NIRV.currentfilters.nottags.includes(tag)) return 'not';
    return '';
  };

  var xViewtoggle = function (val) {
    return NIRV.prefs.UIBTaskDetails && val == NIRV.prefs.UIBTaskDetails.value
      ? 'on'
      : '';
  };

  var due = NIRV.currentfilters.due ? NIRV.L.due : NIRV.L.due;

  var etime = '';
  switch (NIRV.currentfilters.etime) {
    case 0:
      etime = '–';
      break;
    case 5:
      etime = '5m';
      break;
    case 10:
      etime = '10m';
      break;
    case 15:
      etime = '15m';
      break;
    case 30:
      etime = '30m';
      break;
    case 45:
      etime = '45m';
      break;
    case 60:
      etime = '1h';
      break;
    case 120:
      etime = '2h';
      break;
    case 180:
      etime = '3h';
      break;
    case 240:
      etime = '4h';
      break;
    case 360:
      etime = '6h';
      break;
    case 480:
      etime = '8h';
      break;
    case 600:
      etime = '!!';
      break;
    default:
      etime = NIRV.L.time;
  }

  var energy = '';
  switch (NIRV.currentfilters.energy) {
    case 0:
      energy = '–';
      break;
    case 1:
      energy = '•';
      break;
    case 2:
      energy = '••';
      break;
    case 3:
      energy = '•••';
      break;
    default:
      energy = NIRV.L.energy;
  }

  var taskid;
  $('#main li.task').each(function () {
    taskid = $(this).attr('taskid');
    maintasks[taskid] = NIRV.tasks[taskid];
  });

  var atags = [];
  for (i in maintasks) {
    maintaskcount++;
    task = maintasks[i];
    if (typeof task?.__tags__ == 'function') {
      atags = task.__tags__().split(',');
    }
    tasktagcount = 0;
    taskareatagcount = 0;
    if (task.etime != 0) {
      etimeflag = true;
    }
    if (task.energy != 0) {
      energyflag = true;
    }
    for (t = 0; t < atags.length; t++) {
      if (atags[t] != '') {
        ctags.push(atags[t]);
        tasktagcount++;
      }
      if (NIRV.tags[atags[t]] && NIRV.tags[atags[t]].type == NIRV.CONST.AREA) {
        taskareatagcount++;
      }
    }
    if (task.waitingfor != '') {
      ctags.push(task.waitingfor);
    }
    if (task.duedate != '' && task.completed == 0) {
      duecount++;
    }
    if (tasktagcount == 0) {
      noneflag = true;
    }
    if (NIRV.currentarea != '__ALL__' && tasktagcount == taskareatagcount) {
      noneflag = true;
    }
  }

  ctags = ctags.unique();

  var indexof = ctags.indexOf(NIRV.currentarea);
  for (i = 0; i < ctags.length; i++) {
    if (ctags[i].trim() == '') {
      // skip
    } else if (NIRV.tags[ctags[i]] != undefined) {
      if (parseInt(NIRV.tags[ctags[i]].type, 10) == NIRV.CONST.AREA) {
        if (ctags[i] != NIRV.currentarea) {
          areas.push(ctags[i]);
        }
      } else if (i != indexof) {
        contexts.push(ctags[i]);
      }
    }
  }

  areas.sort(isort);
  contexts.sort(isort);

  $('#cbar ul.filters').append('<li class="viewtoggle"></li>');
  $('#cbar ul.filters li.viewtoggle').append(
    '<a class="button fn viewtoggle tri-L single   ' +
      xViewtoggle(1) +
      '" fn="NIRV.setPref" p1="UIBTaskDetails" p2="1" p3="true" title="' + NIRV.L.tooltip_hide_notes + '"><span class="bar"></span></a>'
  );
  $('#cbar ul.filters li.viewtoggle').append(
    '<a class="button fn viewtoggle tri-C double   ' +
      xViewtoggle(2) +
      '" fn="NIRV.setPref" p1="UIBTaskDetails" p2="2" p3="true" title="' + NIRV.L.tooltip_show_notes_preview + '"><span class="bar"></span></a>'
  );
  $('#cbar ul.filters li.viewtoggle').append(
    '<a class="button fn viewtoggle tri-R infinity ' +
      xViewtoggle(3) +
      '" fn="NIRV.setPref" p1="UIBTaskDetails" p2="3" p3="true" title="' + NIRV.L.tooltip_show_notes_full + '"><span class="bar"></span></a>'
  );

  if (NIRV.currentview == 'next') {
    $('#cbar ul.filters').append(
      '<li class="xcmenu options" title="' + NIRV.L.tooltip_next_options + '">•••</li> '
    );
  }
  if (NIRV.currentview == 'focus') {
    $('#cbar ul.filters').append(
      '<li class="xcmenu options" title="' + NIRV.L.tooltip_focus_options + '">•••</li> '
    );
  }
  if (NIRV.currentview == 'projects') {
    $('#cbar ul.filters').append(
      '<li class="xcmenu options" title="' + NIRV.L.tooltip_project_options + '">•••</li> '
    );
  }
  if (NIRV.currentview == 'reflists') {
    $('#cbar ul.filters').append(
      '<li class="xcmenu options" title="' + NIRV.L.tooltip_reference_options + '">•••</li> '
    );
  }
  if (NIRV.currentview == 'logbook') {
    $('#cbar ul.filters').append(
      '<li class="xcmenu options" title="' + NIRV.L.tooltip_logbook_options + '">•••</li> '
    );
  }
  if (NIRV.currentview == 'trash') {
    $('#cbar ul.filters').append(
      '<li class="xcmenu options" title="' + NIRV.L.tooltip_trash_options + '">•••</li> '
    );
  }

  if (maintaskcount != 0) {
    if (
      NIRV.currentfilters.tags.length != 0 ||
      NIRV.currentfilters.nottags.length != 0 ||
      NIRV.currentfilters.etime != -1 ||
      NIRV.currentfilters.energy != -1 ||
      NIRV.currentfilters.due == true
    ) {
      $('#cbar ul.filters').append(
        '<li class="tag all" title="' + NIRV.L.tooltip_remove_filters + '">' + NIRV.L.all + '</li> '
      );
    } else {
      $('#cbar ul.filters').append('<li class="tag all on">' + NIRV.L.all + '</li> ');
    }
  }

  if (duecount != 0) {
    $('#cbar ul.filters').append(
      '<li class="due ' +
        xDue() +
        '" title="' + NIRV.L.tooltip_filter_due + '">' +
        due +
        '</li> '
    );
  }

  if (NIRV.currentview != 'projects') {
    if (etimeflag) {
      $('#cbar ul.filters').append(
        '<li class="xcmenu etime ' +
          xEtime() +
          '" title="' + NIRV.L.tooltip_filter_time + '">' +
          etime +
          '</li> '
      );
    }
    if (energyflag) {
      $('#cbar ul.filters').append(
        '<li class="xcmenu energy ' +
          xEnergy() +
          '" title="' + NIRV.L.tooltip_filter_energy + '">' +
          energy +
          '</li> '
      );
    }
  }

  if (areas.length != 0) {
    for (i = 0; i < areas.length; i++) {
      if (NIRV.currentview[0] == 'p' && NIRV.currentview != 'projects') {
        if (
          NIRV.tasks[NIRV.currentview.substr(1)].tags
            .split(',')
            .indexOf(areas[i]) == -1
        ) {
          $('#cbar ul.filters').append(
            '<li class="tag area ' + xTag(areas[i]) + '">' + areas[i] + '</li> '
          );
        }
      } else {
        $('#cbar ul.filters').append(
          '<li class="tag area ' + xTag(areas[i]) + '">' + areas[i] + '</li> '
        );
      }
    }
  }

  if (contexts.length != 0) {
    for (i = 0; i < contexts.length; i++) {
      if (NIRV.currentview[0] == 'p' && NIRV.currentview != 'projects') {
        if (
          NIRV.tasks[NIRV.currentview.substr(1)].tags
            .split(',')
            .indexOf(contexts[i]) == -1
        ) {
          $('#cbar ul.filters').append(
            '<li class="tag context ' +
              xTag(contexts[i]) +
              '">' +
              contexts[i] +
              '</li> '
          );
        }
      } else {
        $('#cbar ul.filters').append(
          '<li class="tag context ' +
            xTag(contexts[i]) +
            '">' +
            contexts[i] +
            '</li> '
        );
      }
    }
  }

  if (noneflag && contexts.length > 0) {
    $('#cbar ul.filters').append(
      '<li class="tag none ' +
        xTag('__NONE__') +
        '" title="' + NIRV.L.tooltip_filter_no_tags + '">&mdash;</li> '
    );
  }

  if (NIRV.serverVersion && NIRV.serverVersion != NIRV.version) {
    $('#cbar').prepend(
      '<div class="update-available"><b>' + NIRV.L.update_available + '</b><br />' + NIRV.L.update_description + '</div> '
    );
  }

  // NIRV.reflow();
  NIRV.autosave = true;
};

NIRV.setFilter = function (key, value) {
  NIRV.currentfilters[key] = parseInt(value, 10);
  NIRV.refreshCurrentview();
  $(window).scrollTop(0);
};
